
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncKbMapShiftCodeDialog extends Serenity.EntityDialog<PsFuncKbMapShiftCodeRow, any> {
        protected getFormKey() { return PsFuncKbMapShiftCodeForm.formKey; }
        protected getIdProperty() { return PsFuncKbMapShiftCodeRow.idProperty; }
        protected getLocalTextPrefix() { return PsFuncKbMapShiftCodeRow.localTextPrefix; }
        protected getNameProperty() { return PsFuncKbMapShiftCodeRow.nameProperty; }
        protected getService() { return PsFuncKbMapShiftCodeService.baseUrl; }
        protected getDeletePermission() { return PsFuncKbMapShiftCodeRow.deletePermission; }
        protected getInsertPermission() { return PsFuncKbMapShiftCodeRow.insertPermission; }
        protected getUpdatePermission() { return PsFuncKbMapShiftCodeRow.updatePermission; }

        protected form = new PsFuncKbMapShiftCodeForm(this.idPrefix);

    }
}